import { Toaster as Sonner, toast } from "sonner"

// Simple wrapper around sonner's Toaster. Previously this component used
// `useTheme()` from `next-themes`, but that library is not wrapped by a
// ThemeProvider in this app and, under React 19, calling useTheme() without
// a provider causes an infinite re-render loop (Maximum call stack size
// exceeded). Since the app uses a single light theme by design, we hardcode
// theme="light" and drop next-themes entirely.
const Toaster = ({ ...props }) => {
  return (
    <Sonner
      theme="light"
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-muted-foreground",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        },
      }}
      {...props}
    />
  );
}

export { Toaster, toast }
